import { render, staticRenderFns } from "./DataTableHistoryEntityPacks.vue?vue&type=template&id=dc35610e"
import script from "./DataTableHistoryEntityPacks.vue?vue&type=script&lang=js"
export * from "./DataTableHistoryEntityPacks.vue?vue&type=script&lang=js"
import style0 from "./DataTableHistoryEntityPacks.vue?vue&type=style&index=0&id=dc35610e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports